import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef, useContext } from 'react';
import { ListStateContext, ListBoxContext } from 'react-aria-components';
import { useListState } from 'react-stately';
import ListBoxInner from './list-box-inner.esm.js';
import { useContextProps, HiddenContext } from '../../../utils/index.esm.js';
import { CollectionDocumentContext, CollectionPortal, useCollection } from '../collection.esm.js';

function ListBox(props, ref) {
  var _useContextProps = useContextProps(props, ref, ListBoxContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var isHidden = useContext(HiddenContext);
  var state = useContext(ListStateContext);
  var document = useContext(CollectionDocumentContext);

  // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
  // Those components render two copies of their children so that the collection can be built even when the popover is closed.
  // The first copy sends a collection document via context which we render the collection portal into.
  // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
  // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.

  if (document) {
    return /*#__PURE__*/React.createElement(CollectionPortal, props);
  }
  if (state) {
    return isHidden ? null : /*#__PURE__*/React.createElement(ListBoxInner, {
      state: state,
      props: props,
      listBoxRef: ref
    });
  }
  return /*#__PURE__*/React.createElement(StandaloneListBox, {
    props: props,
    listBoxRef: ref
  });
}
function StandaloneListBox(_ref) {
  var props = _ref.props,
    listBoxRef = _ref.listBoxRef;
  var _useCollection = useCollection(props),
    portal = _useCollection.portal,
    collection = _useCollection.collection;
  // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
  props = _objectSpread2(_objectSpread2({}, props), {}, {
    collection: collection,
    children: null,
    items: null
  });
  var state = useListState(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, portal, /*#__PURE__*/React.createElement(ListBoxInner, {
    state: state,
    props: props,
    listBoxRef: listBoxRef
  }));
}

/**
 * A listbox displays a list of options and allows a user to select one or more of them.
 */
var _ListBox = /*#__PURE__*/forwardRef(ListBox);

export { _ListBox as default };
//# sourceMappingURL=list-box.esm.js.map
